import { Component, OnDestroy, OnInit } from "@angular/core";

import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { Subject } from "rxjs";
import { SupportService } from "../../../core/service/support.service";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { locale as portuguese } from "./i18n/pt";

@Component({
    selector: "app-help-section",
    templateUrl: "./help-section.component.html",
    styleUrls: ["./help-section.component.scss"]
})
export class HelpSectionComponent implements OnInit, OnDestroy {
    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        public supportService: SupportService
    ) {
        // Load the translations
        this._fuseTranslationLoaderService.loadTranslations(english, portuguese, spanish);

        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {}

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    helpClick(): void {
        this.supportService.openWpp();
    }
}
